var _circle, _circle2, _circle3, _rect;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgChromMenu = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  enableBackground: "new 0 0 24 24",
  viewBox: "0 0 24 24",
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 2
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 5,
  r: 2
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 19,
  r: 2
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.10169,
  y: 0.30508,
  width: 23.695,
  height: 23.492,
  fill: "none",
  stroke: "#000",
  strokeWidth: 1.5
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChromMenu, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/chrom-menu.ae4c18ef.svg";
export { ForwardRef as ReactComponent };